import { Component, Prop, Vue } from "vue-property-decorator";

import { fetchFileURLByName } from "./StorageHandler";
import { CreateElement } from "vue";

@Component
export default class AutoInstruction extends Vue {
  @Prop() audioLocation!: string;
  @Prop() callbackOnProceed!: (skip?: Boolean) => void;

  private _audioURL!: string;
  private _audioDuration!: string;
  constructor() {
    super();
  }

  async updateAudioLink(path: string) {
    await fetchFileURLByName(path).then(url => {
      this._audioURL = url as string;
      this.$forceUpdate();
    });
    let a: any = this.$refs.audio;
    if (a) a.src = this._audioURL;
  }

  async created() {
    this.$store.subscribe(async (mutation: any, state: any) => {
      if (mutation.type == "REMOVE_CLIP") {
        if (mutation.payload == this.audioLocation) {
          this.performEndingCleanup(false, true);
        }
        this.$forceUpdate();
      }
      if (mutation.type == "SET_CLIP") {
        await this.updateAudioLink(mutation.payload.path);
        this.$forceUpdate();
      }
    });

    await this.updateAudioLink(this.audioLocation);
    let a: any = this.$refs.audio;
    a.addEventListener(
      "timeupdate",
      () => {
        let timeleft = document.getElementById("timeleft"),
          duration = parseInt(a.duration),
          currentTime = parseInt(a.currentTime),
          timeLeft = duration - currentTime,
          s,
          m;

        s = timeLeft % 60;
        m = Math.floor(timeLeft / 60) % 60;

        s = s < 10 ? "0" + s : s;
        m = m < 10 ? "0" + m : m;

        this._audioDuration = m + ":" + s;
        this.$forceUpdate();
      },
      false
    );
  }

  performEndingCleanup(skip?: Boolean, performDispatch?: Boolean) {
    // stop audio playing in case of skip
    let a: any = this.$refs.audio;

    if (a) a.src = "";

    // perform cleanup
    if (!performDispatch)
      this.$store.dispatch("removeClip", this.audioLocation);

    if (this.callbackOnProceed) {
      this.callbackOnProceed(skip);
    }
    this.$forceUpdate();
  }

  updated() {
    let a: any = this.$refs.audio;
    a.addEventListener("ended", this.performEndingCleanup);
  }

  render() {
    if (!this._audioURL) {
      return <span></span>;
    }

    return (
      <div>
        <audio autoplay ref="audio">
          <source src={this._audioURL} type="audio/mp3" />
        </audio>
        <v-btn
          onClick={() => {
            this.performEndingCleanup(true);
          }}
          small
          color="primary"
        >
          Skip Audio Instructions - {this._audioDuration}
        </v-btn>
      </div>
    );
  }
}

const component = AutoInstruction;
